const STORAGE_KEY = 'medical_life_attribution';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export interface Attribution {
  referrer: string;
  gclid: string;
  fbclid: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
}

const hasNewSignal = (params: URLSearchParams, referrer: string): boolean => {
  if (params.get('gclid') || params.get('fbclid')) return true;
  if (UTM_KEYS.some((key) => params.get(key))) return true;
  if (referrer && !referrer.includes(window.location.hostname)) return true;
  return false;
};

export const captureAttribution = (): void => {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const referrer = document.referrer;

  if (!hasNewSignal(params, referrer)) return;

  const attribution: Attribution = {
    referrer: referrer || '',
    gclid: params.get('gclid') || '',
    fbclid: params.get('fbclid') || '',
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || '',
  };

  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
};

export const getAttribution = (): Partial<Attribution> => {
  if (typeof window === 'undefined') return {};

  try {
    return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
  } catch (e) {
    return {};
  }
};
